// extracted by mini-css-extract-plugin
module.exports = {"loader":"styles_loader__2EVyG","spinner":"styles_spinner__1j1WI","spin":"styles_spin__2fgei"};